
export const ObjectUtils = {
  map: <T extends object, R extends object>(object: T, mapper: (key: keyof T, value: any) => readonly [keyof R, any]): R => {

    return Object.entries(object)
      .map(([key, value]) => mapper(key as any, value))
      .reduce<R>((mappedObject, [key, value]) => ({ ...mappedObject, [key]: value }),
        {} as R
      )
  },
  cloneDeep: <T extends object>(object: T): T => {


    if (!object) {
      return object as T
    }

    return JSON.parse(JSON.stringify(object)) as T
    return Object
      .entries(object)
      .map(([key, value]) => [key, typeof value === 'object' ? ObjectUtils.cloneDeep(value) : value])
      .reduce<{ [key: string]: any }>((total, [key, value]) => {
        total[key as string] = value;
        return total;
      },
        {}
      ) as T

  },
  areObjectKeysSame: (object1: object, object2: object, checkedKeys?: string[]) => {
    if (!object1 && !object2) {
      return true;
    }

    if (!object1 || !object2) {
      return true;
    }

    return [
      ...new Set(Object.keys(object1)),
      ...new Set(Object.keys(object2))
    ]
      .reduce((total, key) => {

        if (!checkedKeys?.includes(key)) {
          return total;
        }

        if ((object1 as any)[key] !== (object2 as any)[key]) {
          return false;
        }

        return total;
      },
        true
      )
  },
  deepCompareObjectKeys: (objs: any[]) => {

    const flattenObjectKeys = (obj: any, path: string = ''): string[] => {

      return Object.entries(obj)
        .flatMap(([key, value]) => [
          [path, key].filter(Boolean).join('.'),
          ...(typeof value === 'object' ? flattenObjectKeys(value, [path, key].filter(Boolean).join('.')) : [])
        ])
    }

    const objKeyArrays = objs.map((obj) => flattenObjectKeys(obj));

    const allDistinctKeysSet = new Set(objKeyArrays.flatMap((objKeyArray) => objKeyArray));

    return objKeyArrays.map((keyArray) => [...allDistinctKeysSet].filter((key => !keyArray.includes(key))))
  },


}

